import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const HeaderWrapper = styled.div`
  margin-top: 5px;
`;

export const HeaderItem = styled.th`
  overflow: hidden;
  padding-left: 5px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 1rem;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;

const BaseTr = styled.tr`
  text-decoration: none;
`;

export const ListHead = styled(BaseTr)`
  border-top: 1px solid ${ColorSF2.white};
  height: 33px;
`;

export const Tr = styled(BaseTr)`
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  cursor: pointer;

  &: hover {
    background-color: ${ColorSF2.skyBlue};
  }
`;
export const BaseTd = styled.td`
  overflow: hidden;
  padding-left: 10px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 1rem;
  font-weight: normal;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
`;

export const Thead = styled.thead`
  background-color: ${ColorSF2.paleBlue};
`;

export const Tbody = styled.tbody`
  background-color: ${ColorSF2.white};
`;

export const ScrolledBody = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  margin-bottom: 26px;
`;
